// Components.
import Layout from 'components/Layout/Layout'
import Cart from 'components/Cart'

// Constants.
import { revalidate } from 'lib/constants/revalidate'

import apiService from 'lib/services/pixels-headless/common'

/**
 * Get common data for Cart page.
 */
export async function getStaticProps({ locale = false }) {
  const data = await apiService.getGlobals(locale)

  // Append generic SEO data.
  data.seo = {
    title: 'Happens - Tarjouskori',
    meta: {
      description: 'Omat tarjouspyyntösi',
      'og:description': 'Omat tarjouspyyntösi',
      'og:title': 'Happens Tarjouskori',
      'og:image': null,
      'og:site_name': 'Happens',
      'og:locale': 'fi',
    },
    canonical: 'https://happens.fi/tarjouskori',
    alternative: null,
  }

  return {
    props: {
      data,
    },
    revalidate,
  }
}

export default function Tarjouskori({ data }) {
  return (
    <Layout data={data}>
      <Cart />
    </Layout>
  )
}
